document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".toggle_btn").forEach((btn) => {
    btn.addEventListener("click", function () {
      this.classList.toggle("active-desn");
      document.querySelector(".collection-hero__description").classList.toggle("active-desn");

      if (this.classList.contains("active-desn")) {
        this.textContent = "Read Less";
      } else {
        this.textContent = "Read More";
      }
    });
  });

  document.querySelectorAll(".toggle_btnpp").forEach((btn) => {
    btn.addEventListener("click", function () {
      this.classList.toggle("active-desn");
      document.querySelector(".tab-pane-prd-descriptio").classList.toggle("active-desn");

      let tabPanel = document.querySelector(".tab-panel-prd.accordion-header-content.active");
      if (tabPanel) {
        tabPanel.classList.toggle("removebefore");
      }

      if (this.classList.contains("active-desn")) {
        this.textContent = "Read Less";
      } else {
        this.textContent = "Read More";
      }
    });
  });
});

$(document).ready(function(){
$('.key-features-slideshow').slick({
  dots: true, 
  centerMode: true,
  centerPadding: '1px',
  speed: 300,
  slidesToShow: 2,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 989,
      settings: {        
        centerMode: true,        
        slidesToShow: 1
      }
    }
  ]
});
var stHeight = $('.key-features-slideshow .slick-track').height();
$('.key-features-slideshow .slick-slide').css('height',stHeight + 'px' );  
});  

$(document).ready(function() {
  $(".tab-headers-prd li").click(function() {
    var tabIndex = $(this).index();
    
    $(".tab-headers-prd li").removeClass("active");
    $(this).addClass("active");
    
    $(".tab-panel-prd").removeClass("active");
    $(".tab-panel-prd").eq(tabIndex).addClass("active");
  });
});

$(document).ready(function() {
  $(".accordion-header").click(function() {
    $(this).toggleClass("active");
    $(this).next(".tab-panel-prd").slideToggle();
    $(".accordion-header").not(this).removeClass("active");
    $(".tab-panel-prd").not($(this).next()).hide();     
  });
});


$(document).ready(function() {
if ($(window).width() < 990) {  
$('.review_text').click(function(){
  $(".accordion-header-review-title").addClass("active");
  $(".accordion-header-review-contant").show();
  $(".accordion-header-descriptio").removeClass("active");
  $(".accordion-header-specs").removeClass("active");
  $(".accordion-header-content").hide();
  $(".accordion-header-spec").hide();
   $(".accordion-header-spec").removeClass("active");
  $(".accordion-header-content").removeClass("active");
});
} 
});

$(document).ready(function() {
if ($(window).width() < 750) {  
//$(".template-product .breadcrumbs_main").insertBefore(".product-single__meta");  
} 
});


$(document).ready(function() {
if ($(window).width() < 990) {  
$(".accordion-header-review-title").insertBefore(".accordion-header-descriptio");
$(".accordion-header-review-contant").insertBefore(".accordion-header-descriptio"); 
$(".accordion-header-descriptio").insertAfter(".accordion-header-specs"); 
$(".accordion-header-content").insertAfter(".accordion-header-descriptio");
$(".accordion-header-spec").insertAfter(".accordion-header-specs");
$("#shopify-section-product-details").remove();  
} 
});


$(document).ready(function() {
if ($(window).width() > 989) {  
  $(".desktop-product-page-review").appendTo(".review_with_inner");
  $(".mobile-video-section-tab .video_class").appendTo(".video_with_inner");  

    $(".desktop-product-page-review").appendTo(".review_with_inner");
  $(".mobile-video-section-tab .video_class").appendTo(".video_with_inner");  
} 
});